import i18n from 'i18next';

export default ({ adminSettings }) => {
  const { data: { locales } = {} } = adminSettings;

  return {
    title: {
      type: 'Text',
      label: i18n.t('topic-title'),
      validators: [{ type: 'isRequired' }, { type: 'isNotEmptyString' }],
    },
    description: {
      type: 'TextArea',
      label: i18n.t('description'),
    },
    code: {
      type: 'Text',
      label: i18n.t('code'),
    },
    locale: {
      type: 'Select',
      label: i18n.t('locale'),
      selectProps: {
        isFluid: true,
        isFullWidth: true,
        placeholder: i18n.t('locales-placeholder'),
        noOptionsMessage: () => i18n.t('locales-empty'),
      },
      options: locales?.map(({ key, name }, i) => ({
        id: i,
        label: name,
        value: key,
      })) || [],
      isDisabled: true,
    },
  };
};
